import { createTheme } from "@mui/material/styles";

const themeConfig = (primaryColor) => {
  return createTheme({
    palette: {
      primary: {
        main: '#32CD31',
        light: '#42a5f5',
        dark: '#1565c0',
        contrastText: '#fff',
      },
      secondary:{
        main: '#F3FEF1',
        light: '#42a5f5',
        dark: '#1565c0',
        contrastText: '#fff',
      },
      background: {
        default: '#F0F2F7A6',
        paper: '#F3FEF1'
      }
    },
    typography: {
      fontFamily: 'Rubik',
      primaryColor:'white',
      htmlFontSize: 10,
      fontSize: 14,
      body1: {
        fontSize: "1.4rem"
      }
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          }
        }
      },
    },
  });
};

export default themeConfig;
